export const capitalise = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const stripBase64Metadata = (base64String) => {
  const [, formattedBase64] = base64String.split(/,(.*)/s);

  return formattedBase64;
};
